const MagicWand = (props: any) => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path d="M19.5025 7.5L20.4425 5.44L22.5025 4.5L20.4425 3.56L19.5025 1.5L18.5625 3.56L16.5025 4.5L18.5625 5.44L19.5025 7.5Z" />
    <path d="M8.0025 7.5L8.9425 5.44L11.0025 4.5L8.9425 3.56L8.0025 1.5L7.0625 3.56L5.0025 4.5L7.0625 5.44L8.0025 7.5Z" />
    <path d="M19.5025 13L18.5625 15.06L16.5025 16L18.5625 16.94L19.5025 19L20.4425 16.94L22.5025 16L20.4425 15.06L19.5025 13Z" />
    <path d="M17.2125 9.62L14.3825 6.79C14.1825 6.6 13.9325 6.5 13.6725 6.5C13.4125 6.5 13.1625 6.6 12.9625 6.79L1.7925 17.96C1.4025 18.35 1.4025 18.98 1.7925 19.37L4.6225 22.2C4.8225 22.4 5.0725 22.5 5.3325 22.5C5.5925 22.5 5.8425 22.4 6.0425 22.21L17.2125 11.04C17.6025 10.65 17.6025 10.01 17.2125 9.62ZM13.6725 8.92L15.0825 10.33L13.9125 11.5L12.5025 10.09L13.6725 8.92ZM5.3325 20.09L3.9225 18.68L11.0925 11.5L12.5025 12.91L5.3325 20.09Z" />
  </svg>
);

export default MagicWand;
